import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import Pane from '../components/Pane'

import PaneWrapper from '../components/PaneWrapper'
import Loader from '../../shared/components/Loader'

@inject('user')
@observer
export default class PaneContainer extends Component {

  static propTypes = {
    user: PropTypes.object.isRequired,
  }

  componentWillMount() {
    this.props.user.load()
  }

  render() {

    if (this.props.user.loading) {
      return (
        <PaneWrapper>
          <Loader>Kennungen werden geladen...</Loader>
        </PaneWrapper>
      )
    }

    return (
      <Pane />
    )
  }

}



// WEBPACK FOOTER //
// ./src/user/containers/Pane.js